module.exports = __webpack_public_path__ + "images/05c4de7148934f10f6d1e5e98d44203f-logo.png";